import { AppAreaConfig } from '@/funnels/@types'
import maleActivityCalisthenics from './activity-male-calisthenics'
import femaleActivityCalisthenics from './activity-female-calisthenics'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-calisthenics', 'age-calisthenics'],
		route: {
			path: '/calisthenics',
			name: 'main-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-calisthenics-gender-selection',
		route: {
			path: '/calisthenics/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'calisthenics-survey',
		},
		slug: 'main-calisthenics',
		locale: ['en'],
		redirectTo: {
			sex: {
				male: { appArea: maleActivityCalisthenics },
				female: { appArea: femaleActivityCalisthenics },
			},
		},
	},
}

export default appAreaConfig
